import React from "react";
import { CheckIcon, TargetIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { volumes } from "../../data/volumes";
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-378" data-mp="2x103in9rjx2r">
      <div className="mx-auto max-w-4xl" data-id="element-379" data-mp="2wzgmuvk73k0g">
        <p className="text-center text-sm font-bold uppercase tracking-wide text-gold" data-id="element-380" data-mp="2szyd8vxtqvcx">What you'll find inside</p>
        <h2 className="text-balance mt-3 text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-381" data-mp="2o13icvml1gcg">
          6 premium volumes, <em className="text-gold" data-id="element-382" data-mp="2j8k8o9r0n5cx">one complete system</em>
        </h2>

        <div className="mt-12 space-y-6" data-id="element-383" data-mp="2ebts7lbau7qz">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl border border-navy/10 bg-cream" data-id="element-384" data-mp="29c7fre3aovj8">
              <div className="flex items-center gap-4 bg-navy px-5 py-5 sm:px-8" data-id="element-385" data-mp="25adhtdkhi5mr">
                <span className="font-serif text-5xl font-bold leading-none text-goldlight sm:text-6xl" data-id="element-386" data-mp="20b9c4wwrqq16">{v.numeral}</span>
                <div data-id="element-387" data-mp="334l314edpv3u">
                  <p className="text-xs font-bold uppercase tracking-widest text-white/60" data-id="element-388" data-mp="3342zdmpe0elw">Volume {v.numeral}</p>
                  <h3 className="font-serif text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-389" data-mp="37xnpytoni6b2">{v.title}</h3>
                </div>
              </div>

              <div className="px-5 py-6 sm:px-8 sm:py-8" data-id="element-390" data-mp="2y5rp5av6k235">
                <p className="font-serif text-xl font-semibold italic leading-snug text-navy" data-id="element-391" data-mp="2y46snfpb292n">{v.tagline}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-ink/75" data-id="element-392" data-mp="3qv8bprw4corg">{v.intro}</p>

                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-393" data-mp="3qsui7nh37km0">{v.listLabel}</p>
                {v.ordered ? <ol className="mt-3 space-y-2" data-id="element-394" data-mp="3htr0onxkjd9m">
                    {v.items.map((item, i) => <li key={item} className="flex items-start gap-3 text-[16px] text-ink/85" data-id="element-395" data-mp="21g0sp63bw4up" data-mpi={i}>
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy text-sm font-bold text-white" data-id="element-396" data-mp="26fn73iuw7r53">
                          {i + 1}
                        </span>
                        <span className="pt-0.5" data-id="element-397" data-mp="713exwzpg9ds">{item}</span>
                      </li>)}
                  </ol> : <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-398" data-mp="26z8rfy9k5dr">
                    {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[16px] text-ink/85" data-id="element-399" data-mp="3peksx9j116gp">
                        <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-400" data-mp="3kef9ggmwuq9p" />
                        <span data-id="element-401" data-mp="3ff3rj4at5eqj">{item}</span>
                      </li>)}
                  </ul>}

                <p className="mt-6 flex items-start gap-3 rounded-xl bg-white p-4 text-[15px] font-semibold leading-relaxed text-navy" data-id="element-402" data-mp="3bg38bkof4a30">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-403" data-mp="19mx6i81n2wc5" />
                  {v.outcome}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-404" data-mp="2wj3g1xnzm3vz">
          <CTAButton label="I want all 6 volumes today" data-id="element-405" data-mp="2wibu7ek6zkiw" />
        </div>
      </div>
    </section>;
}